import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/utils/RtkQueryUtils";
import { serialize } from "../../../helpers/utils/Utils";

export const followUpTypesApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchFollowUpTypes: build.query({
            query: (query) => {
                return {
                    url: `/ajax/get-all-follow-up-types?${serialize(query)}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["followUpTypes"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getFollowUpTypeById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-follow-up-type-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["followUpTypeById"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),


        getFollowUpTypeByTenant: build.query({
            query: (tenant) => {
                return {
                    url: `/ajax/get-all-follow-up-by-tenant/${tenant}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ["followUpTypeById"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        updateFollowUpTypeId: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update/follow-up-type/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ["followUpTypeById", "followUpTypes", "userAuditableInfo"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "FollowUp")
            },
        }),

        endFollowUpService: build.mutation({
            query: (productId) => {
                return {
                    url: `/ajax/end-product-follow-up/${productId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ["followUpTypeById", "followUpTypes", "getMyOrders", "getOrderByOrderIdAndType", "orders", "teamAndUserAssignments"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Canceled", "FollowUp")
            },
        }),

        createFollowUpType: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create/follow-up-type`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ["followUpTypes"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "FollowUp")
            },
        }),

        startProductFollowUpAction: build.mutation({
            query: ({ requestBody, productId }) => {
                return {
                    url: `/ajax/start-product-follow-up/${productId}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ["followUpTypes", "getOrderByOrderIdAndType", "orders", "getMyOrders", "teamAndUserAssignments"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "FollowUp")
            },
        }),

    })
})

export const {
    useSearchFollowUpTypesQuery,
    useGetFollowUpTypeByIdQuery,
    useUpdateFollowUpTypeIdMutation,
    useCreateFollowUpTypeMutation,
    useGetFollowUpTypeByTenantQuery,
    useStartProductFollowUpActionMutation,
    useEndFollowUpServiceMutation,
    useLazyGetFollowUpTypeByTenantQuery
} = followUpTypesApi